import React from "react";

interface ParagraphTextProps {
  text: string;
  className?: string;
  paragraphClassName?: string;
}

export function ParagraphText({ text, className, paragraphClassName }: ParagraphTextProps) {
  const paragraphs = React.useMemo(() => {
    return (text || "")
      .trim()
      .split(/\n{2,}/)
      .map((p) => p.split("\n"));
  }, [text]);

  return (
    <div className={className}>
      {paragraphs.map((lines, i) => (
        <p key={i} className={paragraphClassName}>
          {lines.map((line, j) => (
            <React.Fragment key={j}>
              {line}
              {j < lines.length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      ))}
    </div>
  );
}
